import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Banner.css';
import tomato from '../../images/tomato.png';
import lemon from '../../images/lemon.png';
import avacado from '../../images/avacado.png';

function Banner() {
    return (
        <Container>
            <Row className='banner-row-pad'>
                <Col lg={6} sm={12}>
                    <div className="left-text">
                        <h1>
                            Predicting the Shelf <br/>
                            Life and Quality of <br/>
                            Produce, Accurately
                        </h1>
                    </div>
                </Col>
                <Col lg={6} sm={12}>
                    <div className='right-images'>
                        <img src={tomato} alt="" />
                        <img src={avacado} alt="" />
                        <img src={lemon} alt="" />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Banner
